let server_url = '/';

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
   //server_url = "https://picklymenu.com/";
   server_url = "http://127.0.0.1:8000/";
}

export const API = server_url;

let mode = false;


 export function modeCheck(variable) {
   if(mode === false) {
    mode = 'none';
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (let i=0;i<vars.length;i++) {
      const pair = vars[i].split("=");
      if(pair[0] == variable){
        mode = pair[1];
      }
    }
   }
   return mode;
  }



/** WEBPACK FOOTER **
 ** ./src/settings.js
 **/